export default __webpack_public_path__ + "static/media/gallery - intro_01.20136832.jpg";